import React, { useState, useEffect, useCallback } from "react";
import { Layout } from "../../Layout";
import { supabase } from "../../supabaseClient";

// import { schedule_delete } from "../../api/schedule_delete";
import Calendar from "../../components/Calendar";
import { Card } from "../../components/_ui/Card/Card";
import { MediaPane } from "./MediaPane";

import "./styles.css";
import { handleError } from "../../utils/handleError";
import { Post, Posts } from "../../types/api/Post";
import { CalendarGrid } from "../../components/CalendarGrid";
import { CalendarFeed } from "../../components/CalendarFeed";
import { useWindowResizeThreshold } from "../../state/hooks/useWindowResizeThreshold";
import { Plus, X } from "react-feather";
import { FlexAlign } from "../../components/_ui/FlexAlign";

export function Planner() {
  const [selectedPost, setSelectedPost] = useState<Post | null>(null);
  const [calendarPosts, setCalendarPosts] = useState<Posts | null>([]);
  const [activeTab, setActiveTab] = useState<"calendar" | "feed" | "grid">(
    "calendar"
  );
  const [isMediaSelectorOpen, setIsMediaSelectorOpen] = useState(false);
  const isMobileSize = useWindowResizeThreshold();

  const getPosts = useCallback(async () => {
    let { data: posts, error } = await supabase.from("posts").select(
      `
        *,
        posts_media(*),
        posts_for_feeds(
          *,
          feed(*)
        )
      `
    );
    // .order("posts_media.order", "asc");
    if (error) handleError(error);

    if (!posts) return;

    setCalendarPosts(posts as Posts);

    const url = new URL(window.location.href);

    if (url.searchParams.has("postId")) {
      const postId = url.searchParams.get("postId");
      const post = posts.find((p) => p.id.toString() === postId);
      if (post) {
        setSelectedPost(post as Post);
      }
    }
  }, []);

  useEffect(() => {
    getPosts();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Layout>
      <div className="px-6 py-6 lg:flex lg:h-screen lg:items-stretch gap-6">
        {isMobileSize && (
          <>
            {!isMediaSelectorOpen && (
              <div className="fixed bottom-20 left-0 w-100 z-10 flex justify-center">
                <button
                  className="btn btn-primary btn-lg shadow-2xl"
                  onClick={() => setIsMediaSelectorOpen(true)}
                  disabled={isMediaSelectorOpen}
                >
                  <Plus /> Create Post
                </button>
              </div>
            )}
            {isMediaSelectorOpen && (
              <button
                className="btn btn-neutral mb-4"
                onClick={() => setIsMediaSelectorOpen(false)}
              >
                <X /> Close
              </button>
            )}

            <MediaPane
              updatePosts={getPosts}
              selectedPost={selectedPost}
              setSelectedPost={setSelectedPost}
            />
          </>
        )}

        {(!isMobileSize || (isMobileSize && isMediaSelectorOpen)) && (
          <Card
            noPadding
            notFull
            className="file-picker-card h-full mb-0 overflow-hidden max-lg:overflow-auto max-lg:w-full max-lg:h-auto"
          >
            <MediaPane
              updatePosts={getPosts}
              selectedPost={selectedPost}
              setSelectedPost={setSelectedPost}
            />
          </Card>
        )}

        {(!isMobileSize || (isMobileSize && !isMediaSelectorOpen)) && (
          <div className="flex-auto overflow-hidden">
            <div className="tabs tabs-box bg-transparent flex-auto justify-center">
              <button
                className={`tab ${
                  activeTab === "calendar" ? "tab-active" : ""
                }`}
                onClick={() => setActiveTab("calendar")}
                aria-label="Calendar"
              >
                Calendar
              </button>
              <button
                className={`tab ${activeTab === "feed" ? "tab-active" : ""}`}
                onClick={() => setActiveTab("feed")}
                aria-label="Feed"
              >
                Feed
              </button>
              <button
                className={`tab ${activeTab === "grid" ? "tab-active" : ""}`}
                onClick={() => setActiveTab("grid")}
                aria-label="Grid"
              >
                Grid
              </button>
            </div>

            {activeTab === "calendar" && (
              <div className="pt-4">
                <Card
                  notFull
                  noPadding
                  className="p-4 mb-0 grow max-lg:ml-0 h-full"
                >
                  <Calendar
                    posts={calendarPosts!}
                    setSelectedPost={setSelectedPost}
                  />
                </Card>
              </div>
            )}

            {activeTab === "feed" && (
              <div className="mt-4 h-full overflow-y-auto">
                <CalendarFeed
                  posts={calendarPosts!}
                  onPostClick={(post) => setSelectedPost(post)}
                />
              </div>
            )}

            {activeTab === "grid" && (
              <div className="pt-4  h-full overflow-y-auto">
                <CalendarGrid
                  posts={calendarPosts!}
                  onPostClick={(post) => setSelectedPost(post)}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </Layout>
  );
}
